@for (chip of chips; track chip.id + chip.rawValue + chip.value) {
  <ion-button class="active-filter-chip-button" mode="ios" size="small" color="medium-secondary"
    (click)="onRemoveClicked(chip)">
    {{ chip.label | translate }}:
    @if (chip.isValueLoading) {
      <ion-spinner color="medium" slot="end"/>
    } @else {
      {{ chip.value }}
      <ion-icon name="close-outline" slot="end"></ion-icon>
    }
  </ion-button>
}
